var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-data-table',{staticClass:"elevation-4",attrs:{"headers":_vm.headers,"items":_vm.typeCertificates,"items-per-page":10},scopedSlots:_vm._u([{key:"item.edit",fn:function(ref){
var item = ref.item;
return [_c('v-btn',{attrs:{"icon":""},on:{"click":function($event){return _vm.editTypeCertificate(item)}}},[_c('v-icon',[_vm._v("settings")])],1)]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }